import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="voucher-input-numpad"
export default class extends Controller {
  static targets = ["display"]

  connect() {
    this.value = "0"
    this.updateDisplay()
    console.log("Voucher numpad controller connected")
  }

  // Handle numpad button press
  press(event) {
    const key = event.currentTarget.dataset.key

    if (this.value === "0") {
      this.value = key
    } else {
      // Prevent the value from becoming too large
      if (this.value.length < 20) {
        this.value += key
      }
    }

    this.updateDisplay()
  }

  // Clear the display
  clear() {
    this.value = "0"
    this.updateDisplay()
  }

  updateDisplay() {
    try {
      this.displayTarget.textContent = this.value
    } catch (e) {
      console.error("Error updating display:", e)
      this.displayTarget.textContent = "0"
      this.value = "0"
    }
  }

  // Handle confirm button
  async confirm(event) {
    const voucherId = parseInt(this.value)

    const posEl = document.querySelector('[data-controller~="pos"]')
    const posController = posEl && this.application.getControllerForElementAndIdentifier(posEl, 'pos')

    if (!posController) return

    try {
      await posController.cartAction("cart_add_voucher", { voucher_id: voucherId })
    } catch (e) {
      console.error("cart_add_voucher failed:", e)
      alert("잘못된 바우처 ID 입니다.")
      return
    }

    const modalsFrame = document.querySelector('turbo-frame[id="modals"]')
    if (modalsFrame) modalsFrame.innerHTML = ""
  }
}
